import { render, staticRenderFns } from "./views.vue?vue&type=template&id=3582fc46&scoped=true&"
import script from "./views.vue?vue&type=script&lang=js&"
export * from "./views.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3582fc46",
  null
  
)

export default component.exports